import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinSatuan = createAsyncThunk(
    "satuan/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getMinMasterSatuan",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getMinSatuanSearch = createAsyncThunk(
    "satuan/getMinSearch",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getMinMasterSatuan",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                let newObj = [];
                response.data.data.map((item) =>
                    newObj.push({
                        value: item.SatuanID,
                        label: item.NamaSatuan,
                    })
                );
                return {data: newObj};
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getSatuan = createAsyncThunk(
    "satuan/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getMasterSatuan",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const insertSatuan = createAsyncThunk(
    "satuan/insert",
    async ({namaSatuan, satuanID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("namaSatuan", namaSatuan);
        formData.append("satuanID", satuanID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"insertMasterSatuan",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const updateSatuan = createAsyncThunk(
    "satuan/update",
    async ({namaSatuan, idSatuan, status}, thunkAPI) => {
        let formData = new FormData();
        formData.append("namaSatuan", namaSatuan);
        formData.append("satuanID", idSatuan);
        formData.append("status", status);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"updateMasterSatuan",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const satuanSlice = createSlice({
    name: "satuan",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinSatuan.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinSatuan.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinSatuan.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getSatuan.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getSatuan.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getSatuan.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertSatuan.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertSatuan.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertSatuan.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateSatuan.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateSatuan.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateSatuan.pending]: (state) => {
            state.isUpdateFetching = true;
        },
        // UPDATE
        [getMinSatuanSearch.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.minData = payload.data;

            return state;
        },
        [getMinSatuanSearch.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [getMinSatuanSearch.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});

export const satuanSelector = (state) => state.satuan;
